import type { AuthUser } from "~/hooks/useAuth";
import type { PlanTier } from "~/utils/plan-limits";

export const ONBOARDING_PATH = "/onboarding";
export const HOME_PATH = "/";
export const SUBSCRIPTION_PATH = "/subscription";

type PreferenceBag = Record<string, unknown> | null | undefined;

export function planTierFor(user: AuthUser | null | undefined): PlanTier {
  if (!user) return "free";
  return user.subscriptionStatus === "active" ? "pro" : "free";
}

export function hasProAccess(user: AuthUser | null | undefined) {
  return planTierFor(user) === "pro";
}

export function hasEverSubscribed(user: AuthUser | null | undefined) {
  if (!user) return false;
  return Boolean(user.subscriptionEventAt) || hasProAccess(user);
}

export function isInitialOnboardingComplete(user: AuthUser | null | undefined) {
  const preferences = user?.preferences as PreferenceBag;
  return preferences?.initialOnboardingCompleted === true;
}

/**
 * GearSync is free to start, so the only gate after auth is the one-time
 * welcome flow. Paywalls appear at the point a plan limit is reached.
 */
export function getPostAuthPath(user: AuthUser | null | undefined): string {
  if (!user) return "/login";
  if (!isInitialOnboardingComplete(user)) return ONBOARDING_PATH;
  return HOME_PATH;
}

export function withOnboardingComplete(
  preferences: PreferenceBag,
): Record<string, unknown> {
  return {
    ...(preferences && typeof preferences === "object" ? preferences : {}),
    initialOnboardingCompleted: true,
  };
}
